export default __webpack_public_path__ + "static/media/Path3501.6301063e.svg";